import { combineReducers } from 'redux'

// V3
import AdminReducer, {
  initialState as adminSlice,
} from 'src/v3/admin/admin.slice'
import ClassroomReducer, {
  initialState as classroomSlice,
} from 'src/v3/classroom/classroom.slice'
import CreateReducer, {
  initialState as createSlice,
} from 'src/v3/create/create.slice'
import ManageReducer, {
  initialState as manageSlice,
} from 'src/v3/manage/manage.slice'
import LiveReducer, { initialState as liveSlice } from 'src/v3/live/live.slice'
import EventsReducer, {
  initialState as eventsSlice,
} from 'src/v3/events/events.slice'
import ProfileReducer, {
  initialState as profileSlice,
} from 'src/v3/profile/profile.slice'
import ScribeReducer, {
  initialState as scribeSlice,
} from 'src/v3/scribe/scribe.slice'
import SelfPacedReducer, {
  initialState as selfPacedSlice,
} from 'src/v3/self-paced/self-paced.slice'
import SettingsReducer, {
  initialState as settingsSlice,
} from 'src/v3/settings/settings.slice'

const rootReducer = combineReducers({
  admin: AdminReducer,
  classroom: ClassroomReducer,
  create: CreateReducer,
  manage: ManageReducer,
  live: LiveReducer,
  events: EventsReducer,
  profile: ProfileReducer,
  scribe: ScribeReducer,
  selfPaced: SelfPacedReducer,
  settings: SettingsReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export const rootInitialState: RootState = {
  admin: adminSlice,
  classroom: classroomSlice,
  create: createSlice,
  manage: manageSlice,
  live: liveSlice,
  events: eventsSlice,
  profile: profileSlice,
  scribe: scribeSlice,
  selfPaced: selfPacedSlice,
  settings: settingsSlice,
}

export default rootReducer
